import { IRawAdminCommand } from 'models/common.model'
import { adminApi } from 'nove8/api'
import { ProcessingKey } from 'nove8/constants/root-constants'
import { useZustandStore } from 'zustandGlobalStore'
import { getCommandsFromCommandRaw } from '../getCommandsFromCommandRaw'

export const fetchCommands = async (locale: string): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.FETCH_COMMANDS)

  const response = await adminApi.getCommands(locale)

  if (response?.data && response?.success) {
    const responseCommands: IRawAdminCommand[] = response.data?.tricks
    useZustandStore.setState({
      commands: getCommandsFromCommandRaw(responseCommands),
    })
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_COMMANDS)
}
